module.exports = __webpack_public_path__ + "img/cuidados-de-saude.63833b8f.png";